import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onRouteIdChange } from "@/utils";
import { Division, LeagueDivision } from "@/modules/competitions/entity";
export default /*#__PURE__*/_defineComponent({
  __name: 'Show',
  async setup(__props) {
    let __temp, __restore;
    let division = ref();
    ;
    [__temp, __restore] = _withAsyncContext(async () => onRouteIdChange(async id => {
      division.value = await Division.findOneOrFail({
        where: {
          id
        },
        relations: {
          teams: true
        }
      });
      if (division.value instanceof LeagueDivision) {
        await division.value.load('stats');
      }
    })), await __temp, __restore();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, _toDisplayString(_unref(division).stats), 1);
    };
  }
});